export class Constants {
    public static readonly GAME_WIDTH: number = 15041;
    public static readonly GAME_HEIGHT: number = 676;
    public static readonly MAX_DEVICE_WIDTH: number = 4096;

    public static readonly JUMP_DISTANCE: number = -550;
    public static readonly GRAVITY_FORCE: number = 500;
    public static readonly DUDE_X_VELOCITY: number = 250;
    public static readonly DUDE_Y_VELOCITY: number = 50;
    public static  readonly GENERAL_VELOCITY: number = 5;

    public static readonly DEFAULT_WIDTH: number = 1280;
    public static readonly DEFAULT_HEIGHT: number = 676;
    public static readonly MAX_MOBILE_WIDTH: number = 1366;

    public static getWindowHeigth(): number {
        let body: HTMLElement = document.body;
        let html: HTMLElement = document.documentElement;
        let height: number = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );

        return height;
    }

    public static getWindowWidth(): number {
        let body: HTMLElement = document.body;
        let html: HTMLElement = document.documentElement;
        let width: number = Math.max(
            body.scrollWidth,
            body.offsetWidth,
            html.clientWidth,
            html.scrollWidth,
            html.offsetWidth
        );

        return width ;
    }

}
